<template>
    <div class="block-header block-header--has-breadcrumb block-header--has-title">
        <div class="container">
            <div class="block-header__body">
                <div class="flexbox-page-info-container">
                    <div class="flex-item-page-info-breadcrumbs">
                        <nav class="breadcrumb block-header__breadcrumb" aria-label="breadcrumb">
                            <ol class="breadcrumb__list breadcrumb__list-product-detail">
                                <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                                <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                                    <router-link to="/" class="breadcrumb__item-link">Home</router-link>
                                </li>							                                
                                <li class="breadcrumb__item breadcrumb__item--current breadcrumb__item--last" aria-current="page">
                                    <span class="breadcrumb__item-link">Order Parts</span>
                                </li>								                               
                                <li class="breadcrumb__title-safe-area" role="presentation"></li>
                            </ol>
                        </nav>
                    </div>
                    <div class="flex-item-page-info-title">
                        <h1 class="block-header__breadcrumb-slim">Order Parts</h1>
                        <active-vehicle v-if="has_search_vehicle === true"></active-vehicle>
                    </div>
                    <!-- <div style='margin-top:6px;'> -->
                        <!-- <active-vehicle></active-vehicle> -->
                    <!-- </div> -->
                </div>
            </div>
        </div>
        <div class="block">
            <div class="container">
                <base-message v-if="servermessages.length > 0" :servermessages="servermessages"></base-message>
            </div>
        </div>
        
    </div>

    <div class="block-split block-split--has-sidebar">
        <div class="container">
            <div class="block-split__row row no-gutters">
                <search-results-filter 
                ref="search_filter"
                :facet_filters="facets"
                @filter_changed="filter_changed">
                </search-results-filter>

                <div class="block-split__item block-split__item-content col-auto" >
                    <div class="block">
                        <search @show-messages="showMessages"  :source-page="'OrderParts'"></search>
                        <div class="block-space block-space--layout--divider-order-entry"></div>
                        <div class="cart">
                            <order-list></order-list> 
                            <ordercart v-if="this.cart.length > 0"></ordercart>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="block-space block-space--layout--divider-order-entry"></div>
    <div class="block-space block-space--layout--divider-order-entry"></div>
    <div class="block-space block-space--layout--divider-order-entry"></div>
    <div class="block-space block-space--layout--divider-order-entry"></div>
</template>

<script>
// import SearchProducts from './SearchProducts.vue';
import Search from './Search';
import SearchResultsFilter from '../searchresults/SearchResultsFilter';
import Orderlist from './Orderlist';
import Ordercart from './Ordercart';
import ActiveVehicle from '../../common/vehicle/ActiveVehicle';
import { mapGetters } from 'vuex';
import axios from 'axios';
import SolrHelper from '../../../mixins/solr_helper';
// import { sfCustom } from '../../../utilities/customs';

export default {
    name: 'OrderParts',
    components: {
        Search,
        // "order-list-container": OrderListContainer,
        "order-list": Orderlist,
        Ordercart,
        ActiveVehicle,
        SearchResultsFilter
        // SearchProducts
    },
    data() {
        return {
            servermessages: [],
            
            keyword: null,
            facets: {},
        }
    },
    computed: {
        ...mapGetters("cart", [
            "cart",
        ]),

        ...mapGetters([
            "storefront"
        ]),
        ...mapGetters("message", [
            "sharedmessages",
            "sharedmessagestatus"
        ]),
        ...mapGetters(['typahead_str']),

        ...mapGetters('product', ['filter_attr']),

        has_search_vehicle() {
            if(this.storefront){
                return process.env.VUE_SEARCH_VEHICLE;
            }
            return false;
        },

    },
    watch: {
        sharedmessagestatus(newVal) {
        if (newVal === 'complete') {
            // This indicates that messages were stored on the state
            let msgs = this.$store.getters['message/sharedmessages']

            if (msgs["OrderParts"] != undefined) {
            this.servermessages = msgs["OrderParts"];
            }

        }
        this.$store.dispatch("message/resetStatus");

        },
        typahead_str(newVal){
        //   console.log('searching = ' + newVal);
            this.keyword = newVal;
            this.solr_search();
        }
    },
    mixins: [SolrHelper],
    methods: {
        showMessages(messages) {
            this.servermessages = messages;
        },
        solr_search(filters = null) {
            // let filter_uri = this.mx_faceted_filter(filters);
            // 'Color', 'Size', 'Material'
            const ffields = ['IGDESC', 'MCNAME'];

            this.filter_attr.forEach(f => {
                ffields.push(f);
            });
            console.log(ffields);
            
            this.$emit('clear_messages');
            this.parts = [];
            this.isloading = true;

            // let filter_uri = this.mx_multi_facet_filter(filters);
            let json_facet_uri = this.mx_json_facet(ffields);
            let filter_uri = '';
            if(filters != null){
                // console.log('filter is not nULL');
                // filter_uri = this.mx_faceted_filter(filters);
                filter_uri = this.mx_multi_facet_filter(filters);
                // filter_uri = this.mx_get_filter();
                // if(this.$store.getters.customerIndicator == 'C'){
                //     filter_uri += '&fq=Stocks:[1 TO *]';
                // }
            }else{
                // console.log('filter is nULL');
                // defaults filter search
                // &fq=Stocking_Flag:Y
                // filter_uri = '&fq=Stocks:[1 TO *]';
                // console.log(this.$store.getters.solr_faceted_filter);
                filter_uri += this.mx_multi_facet_filter(this.$store.getters.solr_faceted_filter);
            }

            if(this.keyword == null){
                this.keyword = '*';
            }

            filter_uri += json_facet_uri;
            console.log(filter_uri);
            // const solr_core_admin = this.$store.getters.storefrontAttributes.find(attribute => attribute.type === 'SCA');
            const solr_host = this.$store.getters.solr_hostname + '/solr/' + this.$store.getters.solr_coreadmin;
            let uri = solr_host + '/select?q.op=AND&q=Item_Desc%3A*'+this.keyword+'*%20OR%20Item%3A*'+this.keyword+'*&facet.field=IGDESC&facet.field=MCNAME&facet=true&facet.field=Color&f.B2C_price.facet.range.start=0&f.B2C_price.facet.range.end=1000&f.B2C_price.facet.range.gap=100&facet.range=B2C_price&f.Weight.facet.range.start=0&f.Weight.facet.range.end=100&f.Weight.facet.range.gap=10&facet.range=Weight&group=true&group.field=Item&group.facet=true&group.format=simple&group.ngroups=true';
            uri += filter_uri;
            axios.get(uri,{
                auth: {
                    username: this.$store.getters.solr_username,
                    password: this.$store.getters.solr_password
                }
            })
            .then((response) => {
                // console.log(response);
                // const MPARTS = response.data.response.docs;
                this.facets = response.data.facets;
                this.$refs.search_filter.rebuildFilter(this.facets);

                this.isloading = false;
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },

        filter_changed(changed) {
            console.log(changed);
            this.solr_search(changed);
        }
    },
    updated(){
        
    },
    created() {

        this.$store.dispatch('setTypahead_str', '');
        this.solr_search();
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
    }
}
</script>
